import React, { FC } from 'react';
import PullToRefresh from 'react-simple-pull-to-refresh';
import { isAndroid, isIOSApp, isPWA } from 'shared/util/utility';

interface RefreshContent {
	children: React.ReactNode;
	onRefresh: () => Promise<any>;
	className?: string;
	isPullable?: boolean;
}

const RefreshableContent: FC<RefreshContent> = (props) => {
	const { children, onRefresh, className, isPullable = false } = props;

	const isRefreshable = isIOSApp || (isPWA() && isAndroid) || isPullable;

	return (
		<PullToRefresh
			onRefresh={onRefresh}
			isPullable={isRefreshable}
			resistance={4}
			maxPullDownDistance={100}
			className={className}
			pullDownThreshold={90}
		>
			<>{children}</>
		</PullToRefresh>
	);
};

export default RefreshableContent;
